module.exports = __webpack_public_path__ + "img/tabsBtn.c44f9a63.png";